import { ReactComponent as Warning } from 'assets/warningTriangle.svg'
import { selectWarehouse } from '../Warehouses/warehousesSlice'
import useTranslation from 'hooks/useTranslation'
import { useParams } from 'react-router-dom'
import { useReduxSelector } from 'store'
import { DAY } from 'utils/date'
import React from 'react'

interface MagStatusProps {
  warning?: boolean
  isDesktop?: boolean
}

const MagStatus: React.FC<MagStatusProps> = ({ warning = false, isDesktop = false }) => {
  const { id } = useParams<warehouse.PageParams>()
  const { doorState, hasOnlineAccess, inFuture, fullDateFrom } = useReduxSelector(state => selectWarehouse(state, id))
  const days = Math.ceil((new Date(fullDateFrom).getTime() - Date.now()) / DAY)
  const isDoorUnlocked = doorState?.lock === 'unlocked'
  const isDoorOpen = doorState?.door === 'opened'

  const { t } = useTranslation('warehouse')

  return (
    <div className='menu__status'>
      {!isDesktop && <div className='line' />}
      <div className='status__options'>
        {inFuture
          ? <h4>Dostępny za {days === 1 ? '1 dzień' : `${days} dni`}</h4>
          : hasOnlineAccess ? <>
            <div className={`status__option${isDoorUnlocked ? ' --important' : ''}`}>
              <i className={`icon icon--padlock-${isDoorOpen || isDoorUnlocked ? 'open' : 'closed'}`} />
              <span>{t(isDoorOpen ? 'doorsOpen' : isDoorUnlocked ? 'latchOpen' : 'doorsClosed')}</span>
            </div>

            {warning && <div className='status__option'>
              <Warning />
              <span>{t('noFailures')}</span>
            </div>}
          </>
            : <h4>{t('warehouseWithPadlock')}</h4>}
      </div>
    </div>
  )
}

export default MagStatus